import { createContext } from 'preact';

const FilterContext = createContext();
export default FilterContext;
